
import profileimg from "../../Images/blank.jpg";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import InvitationActionCard from "./InvitationCardAction";

export default function InvitationCard({ contact, reloadInvitationList }) {
    const handleAcceptConnectionRequest = async (e, notificationId, senderId) => {
        e.preventDefault()
        const formData = {
            // nonMemberId: UserProfileID?._id,
            nonMemberId: senderId,
            connectionId: notificationId,
            acceptStatus: "Accept"
        };

        const res = await HttpClient.requestData(
            "save-nonmember-contacts",
            "POST",
            formData
        );
        if (res && res?.status) {
            reloadInvitationList()
            toast.success("Request accepted successfully");
        } else {
            toast.error("Error occured");
        }
    };

    const handleReloadList = () => {
        if (reloadInvitationList) {
            reloadInvitationList();
        }
    }

    return (
        <>
            <div
                className="brdrblckdiv "
                key={contact?._id}
                style={{ cursor: "pointer", position: 'relative' }}
            >

                <div className="cntntflx">
                    <div
                        style={{ width: "100%" }}
                    >
                        <div className="cntcnmdtlsmai">
                            <div className="imgvrtdiv">
                                <img
                                    src={
                                        contact?.connectionSendorData?.profilePhoto || profileimg
                                    }
                                    alt="..."
                                />
                            </div>
                            <div className="dtghhnjkd">
                                <div className="responResFig">
                                    <span className="prdltxtflx">
                                        <p className="jhntxtlws">
                                            {contact?.connectionSendorData?.personName}
                                        </p>
                                        <p className="mrttxtt">
                                            {contact?.connectionSendorData?.designation}
                                        </p>

                                    </span>

                                </div>

                                <span className="prdltxtflx wrapbox">
                                    <p className="cmpntyxt">
                                        {contact?.connectionSendorData?.companyName}
                                    </p>
                                    <p className="dghttxt">
                                        {contact?.connectionSendorData?.TypeOfCompany}
                                    </p>
                                </span>
                                <span className="prdltxtflx">
                                    <button onClick={(e) => handleAcceptConnectionRequest(e, contact?._id, contact?.connectionSendorId, contact?.userId)} className='btn btn-sm btn-success'>Accept</button>

                                </span>

                            </div>
                        </div>
                    </div>

                    <InvitationActionCard key={contact?._id} contact={contact} reloadList={handleReloadList} />
                </div>
            </div>
        </>
    )
};